module.exports = __webpack_public_path__ + "static/img/createSkill.ce75d5f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/skillTutor/createSkill.png
// module id = KM+6
// module chunks = 1